
import { defineComponent } from "vue";
export default defineComponent({
  name: "element-plus-clear-icon",
})
